// Get DOM elements
const navbar = document.getElementById('header-group');
const heroLogo = document.getElementById('heroLogo');

// Configuration
const CONFIG = {
    triggerPoint: 300,      // Pixels to scroll before animation completes
    scrollThreshold: 50,    // When to show navbar
    scaleRange: 0.6,        // How much to scale down (1 - 0.6 = 0.4 final scale)
};

/**
 * Calculate scroll progress as a value between 0 and 1
 * @param {number} scrollPosition - Current scroll position in pixels
 * @returns {number} Progress value between 0 and 1
 */
function calculateScrollProgress(scrollPosition) {
    return Math.min(scrollPosition / CONFIG.triggerPoint, 1);
}

/**
 * Calculate scale value based on scroll progress
 * @param {number} progress - Scroll progress (0 to 1)
 * @returns {number} Scale value
 */
function calculateScale(progress) {
    return 1 - (progress * CONFIG.scaleRange);
}

/**
 * Calculate opacity for hero logo
 * @param {number} scrollPosition - Current scroll position
 * @returns {number} Opacity value (0 or 1)
 */
function calculateHeroOpacity(scrollPosition) {
    return scrollPosition > CONFIG.scrollThreshold ? 0 : 1;
}

/**
 * Update navbar state based on scroll position
 * @param {number} scrollPosition - Current scroll position
 */
function updateNavbar(scrollPosition) {
    if (scrollPosition > CONFIG.scrollThreshold) {
        navbar.classList.add('show');
        navbar.classList.remove('hide');
    } else {
        navbar.classList.remove('show');
        navbar.classList.add('hide');
    }
}

/**
 * Update hero logo transform and opacity
 * @param {number} scale - Scale value to apply
 * @param {number} opacity - Opacity value to apply
 */
function updateHeroLogo(scale, opacity) {
    heroLogo.style.transform = `scale(${scale})`;
    heroLogo.style.opacity = opacity;
}

/**
 * Main scroll handler - orchestrates all scroll-based animations
 */
function handleScroll() {
    // Get current scroll position
    const scrollPosition = window.scrollY;
    
    // Calculate animation values
    const progress = calculateScrollProgress(scrollPosition);
    const scale = calculateScale(progress);
    const opacity = calculateHeroOpacity(scrollPosition);
    
    // Update UI elements
    updateNavbar(scrollPosition);
    updateHeroLogo(scale, opacity);
}

/**
 * Throttle function to limit how often a function can be called
 * Improves performance by reducing the number of scroll event handlers
 * @param {Function} func - Function to throttle
 * @param {number} delay - Minimum time between function calls in ms
 * @returns {Function} Throttled function
 */
function throttle(func, delay) {
    let lastCall = 0;
    return function(...args) {
        const now = Date.now();
        if (now - lastCall >= delay) {
            lastCall = now;
            func.apply(this, args);
        }
    };
}

/**
 * Request Animation Frame version for smoother animations
 * More efficient than throttle for scroll animations
 */
let ticking = false;

function requestScrollUpdate() {
    if (!ticking) {
        window.requestAnimationFrame(() => {
            handleScroll();
            ticking = false;
        });
        ticking = true;
    }
}

/**
 * Initialize the scroll animation
 */
function init() {
    // Set initial state
    handleScroll();
    
    // Add scroll event listener with requestAnimationFrame for smooth performance
    window.addEventListener('scroll', requestScrollUpdate, { passive: true });
    
    // Alternative: Use throttled version if you prefer
    // window.addEventListener('scroll', throttle(handleScroll, 16), { passive: true });
    
    console.log('Logo scroll animation initialized');
}

/**
 * Cleanup function (useful if you need to remove the animation)
 */
function destroy() {
    window.removeEventListener('scroll', requestScrollUpdate);
    console.log('Logo scroll animation destroyed');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    // DOM is already loaded
    init();
}

// Export functions for use in other scripts (optional)
// Useful if you want to control the animation programmatically
window.LogoScrollAnimation = {
    init,
    destroy,
    handleScroll,
    CONFIG
};


